import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { EventEmitter } from '@angular/core';
// Angular
import { Component, Inject, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertType } from '@uw/shared/models/alert.model';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatButton } from '@angular/material/button';
import { SafeHtmlPipe } from '../../../pipes/safe-html.pipe';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'uw-confirm-entity-dialog',
    styleUrls: ['./confirm-entity-dialog.component.scss'],
    templateUrl: './confirm-entity-dialog.component.html',
    imports: [MatProgressBar, MatButton, TranslateModule, SafeHtmlPipe]
})
export class ConfirmEntityDialogComponent implements OnInit {
  // Public properties
  viewLoading = false;
  confirmed$ = new BehaviorSubject<boolean>(false);
  alertTypeEnum = AlertType;
  cancelBtnText;
  constructor(
    public dialogRef: MatDialogRef<ConfirmEntityDialogComponent>,
    private translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.cancelBtnText = this.translateService.instant('common.cancel');
  }

  ngOnInit() {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  singleBtnClick(): void {
    this.confirmed$.next(true);
    this.dialogRef.close();
  }

  onYesClick(): void {
    this.viewLoading = true;
    this.confirmed$.next(true);
  }

  public confirmed(): Observable<boolean> {
    return this.confirmed$.asObservable();
  }

  public closeDialog() {
    this.dialogRef.close();
  }
}
